<template>
  <div id="home" class="min-h-screen text-NotoSansRegular" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">

    <IndexBanner :bannerData="bannerData" />

    <div class="px-2 md:px-6 mx-auto max-w-index">
      <!-- 當月雜誌 -->
      <Indexmagazine :magazineData="magazineData" />

      <!-- 本月企劃 -->
      <MonthyPlan :planData="planData" v-if="planData && planData.length > 0" />

      <!-- 站長推薦 -->
      <Recommend :friendlyData="friendlyData" v-if="friendlyData && friendlyData.length > 0" />

      <!-- 影片介紹 -->
      <!-- <IndexFilm :filmData="filmData" v-if="filmData && filmData.length > 0" /> -->

      <!-- 精選叢書/套書推薦 -->
      <div class="slider-books pb-6 md:pb-8 border-b w-full">
        <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack" v-if="bookNewData && bookNewData.length > 0">新書上架</h3>
        <IndexBook :indexBookData="bookNewData" :bgColorList="bgColorList" v-if="bookNewData && bookNewData.length > 0" />

        <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack" v-if="bookBestSeller && bookBestSeller.length > 0">暢銷叢書</h3>
        <IndexBook :indexBookData="bookBestSeller" :bgColorList="bgColorListSeller" v-if="bookBestSeller && bookBestSeller.length > 0" />

          <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack" v-if="packageData && packageData.length > 0">暢銷點讀套書</h3>
        <!-- package -->
        <IndexPackage :packageData="packageData" v-if="packageData && packageData.length > 0" />

      </div>

      <!-- 主題專欄 -->
      <!-- <IndexTopic v-if="$store.state.nodeEnv !== 'production' && articleData && articleData.length > 0"
        :articleData="articleData" /> -->
      <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack" v-if="(filmData && filmData.length > 0) || (unboxingData && unboxingData.length > 0)">叢書開箱</h3>
      <IndexFilm :filmData="filmData" v-if="filmData && filmData.length > 0" />
      <IndexFilm :filmData="unboxingData" v-if="unboxingData && unboxingData.length > 0" />

    </div>
  </div>
</template>
<script src="//jscdn.appier.net/aa.js?id=store.liveabc.com" async></script>
<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import IndexBanner from '@/components/index/Banner'
import Indexmagazine from '@/components/index/MonthyMag'
import MonthyPlan from '@/components/index/MonthyPlan'
import Recommend from '@/components/index/Recommend'
import IndexFilm from '@/components/index/Film'
import IndexTopic from '@/components/index/Topic'
import IndexPackage from '@/components/index/Package'
import IndexBook from '@/components/index/Book'
import { mapGetters } from 'vuex'
export default {
  name: 'Index',
  metaInfo () {
    return {
      title: 'LiveABC 互動英語教學集團',
      titleTemplate: null,
      meta: [
        { vmid: 'title', property: 'og:title', content: 'LiveABC 互動英語教學集團 | 數位語言學習第一品牌' },
        { vmid: 'url', property: 'og:url', content: 'https://store.liveabc.com/' },
        { vmid: 'description', name: 'description', content: 'LiveABC的集團事業版圖橫跨出版、教育及數位內容等產業，提供全方位數位語言學習產品，出版ABC互動英語、Live互動英語、ALL+互動英語、CNN互動英語、互動日本語、知識大圖解(How It Works)系列雜誌刊物，以及各式叢書、教科書、線上學習平台等服務，並整合了LiveABC點讀筆、電腦影音互動學習軟體等學習工具，滿足各階段的學習需求。' },
        { vmid: 'og:description', property: 'og:description', content: 'LiveABC的集團事業版圖橫跨出版、教育及數位內容等產業，提供全方位數位語言學習產品，出版ABC互動英語、Live互動英語、ALL+互動英語、CNN互動英語、互動日本語、知識大圖解(How It Works)系列雜誌刊物，以及各式叢書、教科書、線上學習平台等服務，並整合了LiveABC點讀筆、電腦影音互動學習軟體等學習工具，滿足各階段的學習需求。' }
      ]
    }
  },
  components: {
    IndexBanner,
    Indexmagazine,
    MonthyPlan,
    IndexTopic,
    Recommend,
    IndexFilm,
    IndexPackage,
    IndexBook
  },
  mixins: [
  ],
  data () {
    return {
      bannerData: null,

      // 當月雜誌
      magazineData: null,

      // 當月企劃
      planData: null,

      // 友情連結
      friendlyData: null,

      // 叢書館
      bookNewData: null,
      bgColorList: ['#f6e58d', '#f8a5c2', '#ffbe76', '#63cdda', '#ff7979', '#ea8685', '#badc58', '#596275', '#dff9fb', '#786fa6', '#cf6a87', '#dcdde1'],

      bookBestSeller: null,
      bgColorListSeller: ['#f6e58d', '#f8a5c2', '#ffbe76', '#63cdda', '#ff7979', '#ea8685', '#badc58', '#596275', '#dff9fb', '#786fa6', '#cf6a87', '#dcdde1'],

      // 套書館
      packageData: null,

      // 主題專欄
      // articleData: null,

      // 影片
      filmData: null,
      unboxingData: null
    }
  },
  created () {
    this.$store.dispatch('isLoading', true)
    this.getBanner()
    this.getMag()
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user',
      'userRole'
    ])
  },
  mounted () {
  },
  methods: {
    getBanner () {
      axios.get('/ad/IndexBanner')
        .then((response) => {
          this.bannerData = response.data
        })
    },
    getMag () {
      let arr = [
        { category_id: 123, introduction: '基礎、活用' },
        { category_id: 124, introduction: '生活、實用' },
        { category_id: 125, introduction: '進階、應用' },
        { category_id: 126, introduction: '時事、新知' },
        { category_id: 121, introduction: '科普、圖解' },
        { category_id: 122, introduction: '日語、會話' }
      ]
      axios.get('/newest-magazines/')
        .then((response) => {
          response.data.forEach(item1 => {
            arr.forEach(item2 => {
              if (item1.category_id === item2.category_id) {
                Object.assign(item1, item2)
              }
            })
          })
          this.magazineData = response.data

          this.getMonthy()
        })
    },
    getMonthy () {
      axios.get('/ad/activity')
        .then((response) => {
          this.planData = response.data

          this.getBook()
          this.getBookBestSeller()
          this.getPackage()
          this.getFriendlyLink()
          this.getFilms()
          this.getFilmsUnboxing()
        })
    },
    getFilms () {
      axios.get('/ad/indexFilm')
        .then((response) => {
          this.filmData = response.data
        })
    },
    getFilmsUnboxing () {
      axios.get('/ad/unboxing')
        .then((response) => {
          this.unboxingData = response.data
        })
    },
    async getBook () {
      // 叢書
      let path = '/products?type=BOOK,PHYSICAL&page=1&pageSize=8&scope=new_arrival&sort=published_at'
      const response = await axios.get(path)
      this.bookNewData = response.data.data
      this.getColorListNew()
      this.getColorListSeller()
    },
    async getBookBestSeller () {
      // 叢書
      let path = '/products?type=BOOK,PHYSICAL&page=1&pageSize=8&sort=sold&sortBy=desc'
      const response = await axios.get(path)
      this.bookBestSeller = response.data.data
      this.getColorListNew()
      this.getColorListSeller()
    },
    async getPackage () {
      // 套書
      let path = '/products?page=1&pageSize=9&scope=smartpen_package_series&sort=published_at'
      await axios.get(path)
        .then((response) => {
          this.packageData = response.data.data
          this.$store.dispatch('isLoading', false)
        })
    },
    getFriendlyLink () {
      axios.get('/ad/friendlyLink')
        .then((response) => {
          this.friendlyData = response.data
        })
    },

    getColorListNew () {
      if (this.bookNewData) {
        let BookLen = this.bookNewData.length
        let ColorLen = this.bgColorList.length

        if (BookLen > 0 && ColorLen < BookLen) {
          let ln = ColorLen
          let times = ColorLen + (BookLen - ColorLen)
          this.bgColorList = Array.from({ length: times }, (e, i) => this.bgColorList[i % ln])
        }
      }
    },
    getColorListSeller () {
      if (this.bookBestSeller) {
        let BookLen = this.bookBestSeller.length
        let ColorLen = this.bgColorListSeller.length

        if (BookLen > 0 && ColorLen < BookLen) {
          let ln = ColorLen
          let times = ColorLen + (BookLen - ColorLen)
          this.bgColorListSeller = Array.from({ length: times }, (e, i) => this.bgColorListSeller[i % ln])
        }
      }
    }
  }
}

</script>
<style lang="scss">
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-button-next-index {
    right: -4rem !important;
    background-image: url('~@/assets/btn/arrowRight.png') !important;
    background-size: contain !important;
    background-size: 30px 30px !important;
    background-position: center !important;
    width: 50px !important;
    height: 100% !important;
    transform: translateY(-50%) !important;
  }
  .swiper-button-prev-index {
    left: -4rem !important;
    background-image: url('~@/assets/btn/arrowLeft.png') !important;
    background-size: contain !important;
    background-size: 30px 30px !important;
    background-position: center !important;
    width: 50px !important;
    height: 100% !important;
    transform: translateY(-50%) !important;
  }
</style>
